import BaseClass from "../BaseClass";
import {isBoolean} from "lodash";

export default class Shift4Form extends BaseClass {
    constructor(element) {
        super(element);

        this.initElements();
        this.initListeners();

        this.shift4 = null;
        this.shift4ComponentGroup = null;

        this.submitter = undefined;
        this.submitting = false;

        this.translateErrorJqXHR = null;

        $(document).trigger('shift4:api:load', {callback: $.proxy(this.onShift4Loaded, this)});
    }

    initElements() {
        this.$shift4Container = this.$element.find('.shift4-form');
        this.$tokenInput = this.$element.find('input.shift4-token');
        this.$iframes = this.$shift4Container.find('iframe');
        this.$paymentProviderTokenInputs = this.$element.find('[name^="payment_providers[token]"]');
        this.$cardOptions = this.$element.find('[name^="payment_providers[providers]"][name$="[card]"]');
        this.$shift4CardOptions = this.$cardOptions.filter('[name$="[shift4][card]"]');
        this.$otherCardOptions = this.$cardOptions.not(this.$shift4CardOptions);
        this.$newCardOption = this.$cardOptions.filter(function () {
            const $cardOption = $(this);

            return $cardOption.val() == 'new';
        });
        this.$cardholderInput = this.$element.find('[name="payment_providers[providers][shift4][cardholder]"]');
        this.$form = $(this.element.form);
        this.$address = this.$form.find('fieldset[name="address"]');
        this.$articles = this.$form.find('fieldset[name="articles"] > fieldset[name^="article"]');
    }

    initListeners() {
        this.$cardholderInput.on('focusin', $.proxy(this.onCardholderFocus, this));

        this.$cardOptions.on('change', $.proxy(this.onCardOptionChanged, this));

        this.$form.on('form:failing', $.proxy(this.onFormFail, this));
        this.$form.on('submit', $.proxy(this.onFormSubmit, this));
        this.$form.on('reset', $.proxy(this.onFormReset, this));

        // submit listener muss zuerst laufen, da dieser potentiell abbricht.
        for (const form of this.$form.get()) {
            const formEvents = $._data(form, 'events');

            if (formEvents['submit'] != undefined) {
                const submitEvent = formEvents['submit'].splice(-1, 1).pop();
                formEvents['submit'].unshift(submitEvent);
            }
        }

        $(document).on('focusout', $.proxy(this.onDocumentFocusOut, this));
    }

    onShift4Loaded(shift4) {
        this.shift4 = shift4;
        this.shift4ComponentGroup = this.shift4.createComponentGroup();

        if (this.$shift4Container.length == 1) {
            this.shift4ComponentGroup.automount(this.$shift4Container.get(0));

            this.$iframes = this.$shift4Container.find('iframe');
        }
    }

    onFormReset(event) {
        this.clear();
    }

    onFormSubmit(event, data) {
        if (this.hasValidToken() || this.$element.prop('disabled')) {
            return;
        }

        const submitter = event?.originalEvent?.submitter;

        if (submitter != undefined && submitter.value != 'execute') {
            return;
        }

        const $selectedCardOption = this.$cardOptions.filter(':checked');
        const selectedCardOptionProvider = $selectedCardOption.data('provider');

        if (selectedCardOptionProvider != 'shift4') {
            return;
        }

        const cardToken = $selectedCardOption.data('shift4-token');
        if (cardToken == undefined && !this.hasCompleteAdditionalData()) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.submitting) {
            return;
        }

        this.submitting = true;
        this.submitter = submitter;

        if (cardToken == undefined) {
            this.shift4.createToken(this.shift4ComponentGroup, this.getAdditionalFields())
                .then($.proxy(this.onCreateTokenSuccess, this))
                .catch($.proxy(this.onCreateTokenError, this));
        } else {
            this.onCreateTokenSuccess({id: cardToken});
        }
    }

    onFormFail(event, errors) {
        this.handleError();
    }

    onCreateTokenSuccess(token) {
        const currency = this.$element.data('shift4-currency');
        const currencySubunitFaktor = this.$element.data('shift4-currency-subunit-faktor');

        if (currencySubunitFaktor == undefined || currency == undefined) {
            this.checkToken(token);

            return;
        }

        const amount = this.getAmount(currency);
        if (amount == 0) {
            this.checkToken(token);

            return;
        }

        this.shift4.verifyThreeDSecure({card: token.id, currency, amount})
            .then($.proxy(this.onThreeDsCompleted, this))
            .catch($.proxy(this.onThreeDsError, this));
    }

    onCreateTokenError(error) {
        this.handleError(error)
    }

    onThreeDsCompleted(token) {
        this.checkToken(token);
    }

    onThreeDsError(error) {
        this.handleError(error);
    }

    checkToken(token) {
        if (token?.threeDSecureInfo?.liabilityShift == 'failed') {
            this.handleError();

            return;
        }
        this.ready(token);
    }

    ready(token) {
        if (token?.id == undefined) {
            return;
        }

        this.$tokenInput.val(token.id);

        const submitEvent = new SubmitEvent('submit', {submitter: this.submitter});

        this.submitting = false;
        this.submitter = undefined;

        this.$form.trigger($.Event(submitEvent));
    }

    hasValidToken() {
        const tokenVal = this.$tokenInput.val();

        if (typeof tokenVal != 'string') {
            return false;
        }

        if (tokenVal.startsWith('tok_') || tokenVal.startsWith('card_')) {
            return true;
        }

        return false;
    }

    clear() {
        this.$tokenInput.val('');
    }

    getAdditionalFields() {
        const additionalFields = {cardholderName: this.getCardholderName()};

        const address = this.getAddress();
        if (typeof address.street == 'string' && address.street.trim().length > 0) {
            additionalFields.addressLine1 = address.street;

            if (typeof address.street_number == 'string' && address.street_number.trim().length > 0) {
                additionalFields.addressLine1 += ' ' + address.street_number;
            }
        }

        if (typeof address.city == 'string' && address.city.trim().length > 0) {
            additionalFields.addressCity = address.city;
        }

        if (typeof address.postal_code == 'string' && address.postal_code.trim().length > 0) {
            additionalFields.addressZip = address.postal_code;
        }

        if (typeof address.country == 'string' && address.country.trim().length > 0) {
            additionalFields.addressCountry = address.country;
        }

        return additionalFields;
    }

    hasCompleteAdditionalData() {
        const address = this.getAddress();
        for (const [field, value] of Object.entries(address)) {
            if (typeof value != 'string' || !value.trim().length) {
                return false;
            }
        }

        const cardholderName = this.getCardholderName();
        if (typeof cardholderName != 'string' || !cardholderName.trim().length) {
            return false;
        }

        return true;
    }

    getCardholderName() {
        return this.$cardholderInput.val();
    }

    getAddress() {
        return {
            street: this.$address.find('[name$="[street]"]').val(),
            street_number: this.$address.find('[name$="[street_number]"]').val(),
            city: this.$address.find('[name$="[city]"]').val(),
            postal_code: this.$address.find('[name$="[postal_code]"]').val(),
            country: this.$address.find('[name$="[country]"]').val(),
        };
    }

    getAmount(currency) {
        const currencySubunitFaktor = this.$element.data('shift4-currency-subunit-faktor');

        let amount = 0;

        this.getActiveArticles()
            .filter(function () {
                return $(this).find('[name$="[currency]"]').val() == currency;
            })
            .each(function () {
                const $article = $(this);

                const articleRequiredAuthorizationAmount = $article.find('[name$="[required_authorization_amount]"]').val();
                if (typeof articleRequiredAuthorizationAmount == 'string' && articleRequiredAuthorizationAmount.trim() != '') {
                    amount += Math.round(Number.parseFloat(articleRequiredAuthorizationAmount) * currencySubunitFaktor);
                } else {
                    const articleTotal = $article.find('[name$="[price]"]').val();

                    if (typeof articleTotal == 'string' && articleTotal.trim() != '') {
                        amount += Math.round(Number.parseFloat(articleTotal) * currencySubunitFaktor);
                    }
                }
            });

        return amount;
    }

    getActiveArticles() {
        return this.$articles.filter(':not(:disabled)').filter(function () {
            const $article = $(this);

            const $active = $article.find('[name$="[active]"]');

            if (JSON.parse($active.val()) != true) {
                return false;
            }

            if ($active.is(':disabled').length) {
                return false;
            }

            if ($active.is('checkbox, radio, select').length && $active.not(':checked').length) {
                return false;
            }

            return true;
        });
    }

    onDocumentFocusOut() {
        const self = this;

        window.setTimeout($.proxy(this.checkActiveShift4Iframe, this), 0);
    }

    handleError(error) {
        this.submitting = false;
        this.submitter = undefined;

        this.clear();

        if (error !== undefined) {
            this.triggerTranslatedError(error);
        }
    }

    triggerTranslatedError(error) {
        const self = this;

        const url = this.$element.data('error-translate-url');
        if (url === undefined) {
            return;
        }

        if (this.translateErrorJqXHR !== null) {
            this.translateErrorJqXHR.abort();
            this.translateErrorJqXHR = null;
        }

        this.translateErrorJqXHR = $.post({
            url, contentType: 'application/json', dataType: 'json', data: JSON.stringify(error),
        })
            .done($.proxy(this.onTranslateErrorSuccess, this))
            .always(function () {
                self.translateErrorJqXHR = null;
            });
    }

    onTranslateErrorSuccess(errorMessage, textStatus, jqXHR) {
        if (errorMessage?.errors != undefined) {
            this.$element.trigger('form:error:add', {errors: {'': errorMessage.errors}});
        }
    }

    onCardholderFocus() {
        this.selectNewCard();
    }

    checkActiveShift4Iframe() {
        const $activeElement = $(document.activeElement);
        const $activeIframe = this.$iframes.filter($activeElement);

        if ($activeIframe.length > 0) {
            this.selectNewCard();
        }
    }

    onCardOptionChanged(event) {
        const $cardOption = $(event.currentTarget);
        const provider = $cardOption.data('provider');

        const $paymentProviderTokenInput = this.$paymentProviderTokenInputs.filter(function () {
            const $paymentProviderTokenInput = $(this);

            return $paymentProviderTokenInput.val() == provider;
        });

        this.$paymentProviderTokenInputs.not($paymentProviderTokenInput).prop('checked', false);
        $paymentProviderTokenInput.prop('checked', true);

        $paymentProviderTokenInput.trigger('change');
    }

    selectNewCard() {
        this.$cardOptions.not(this.$newCardOption).prop('checked', false);
        this.$newCardOption.prop('checked', true);

        this.$newCardOption.trigger('change');
    }

    destroyListener() {
        if (this.translateErrorJqXHR !== null) {
            this.translateErrorJqXHR.abort();
        }

        delete this.translateErrorJqXHR;
        delete this.shift4ComponentGroup;
        delete this.shift4;

        this.teardownListeners();
        this.teardownElements();

        super.teardown();
    }

    teardownElements() {
        delete this.$address;
        delete this.$articles;
        delete this.$form;
        delete this.$shift4Container;
        delete this.$tokenInput;
        delete this.$iframes;
        delete this.$newCardOption;
        delete this.$otherCardOptions;
        delete this.$shift4CardOptions;
        delete this.$cardOptions;
        delete this.$paymentProviderTokenInputs;
        delete this.$cardholderInput;
    }

    teardownListeners() {
        $(document).off('focusout', $.proxy(this.onDocumentFocusOut, this));

        this.$cardholderInput.off('focusin', $.proxy(this.onCardholderFocus, this));
        this.$cardOptions.off('change', $.proxy(this.onCardOptionChanged, this));
        this.$form.off('form:failing', $.proxy(this.onFormFail, this));
        this.$form.off('submit', $.proxy(this.onFormSubmit, this));
        this.$form.off('reset', $.proxy(this.onFormReset, this));
    }
}